// ** React Imports
import { lazy } from 'react';

const List = lazy(() => import('../../views/income'));

const IncomeRoutes = [
  {
    element: <List />,
    path: '/income',
    meta: {
      permission: 'INCOME'
    }
  }
];

export default IncomeRoutes;
